module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {}, [_c('div', {
    staticClass: "upper-parent"
  }, [_c('div', {
    staticClass: "upper-parent-child1"
  }, [_c('div', {
    staticClass: "same-line itemsContainer inline-block"
  }, [_c('div', {
    staticClass: "offer-name"
  }, [(_vm.gettersSelectedOffer && _vm.gettersSelectedOffer.name) ? _c('div', [_vm._v("\n              " + _vm._s(this.gettersSelectedOffer.name) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.duplicatedItemName && _vm.duplicatedItemName.name) ? _c('div', {
    staticClass: "item-text"
  }, [_vm._v("\n              " + _vm._s(_vm.duplicatedItemName.name) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('searchable-dropdown', {
    attrs: {
      "id": "simulation1",
      "list": _vm.itemArrays,
      "selectedItem": _vm.selectedItem ? _vm.selectedItem.name : ''
    },
    model: {
      value: (_vm.selectedItem),
      callback: function($$v) {
        _vm.selectedItem = $$v
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "upper-parent-child2"
  }, [_c('div', {
    staticClass: "marginLeft inline-block",
    style: ({
      'width': '90%'
    })
  }, [_c('div', {
    staticClass: "margin-top-3"
  }, [_c('span', {
    staticClass: "slider-title"
  }, [_vm._v("\n              Vendor Allowance\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "marginRight padding1"
  }, [_c('vue-slider', {
    style: (_vm.style),
    attrs: {
      "data": _vm.slider1Data,
      "refresh": _vm.refresh,
      "width": _vm.width,
      "tooltip": true,
      "disabled": _vm.slider1Disabled,
      "piecewise": true,
      "piecewiseLabel": true,
      "piecewiseStyle": _vm.piecewiseStyle,
      "piecewiseActiveStyle": _vm.piecewiseActiveStyle,
      "labelActiveStyle": _vm.labelActiveStyle,
      "processStyle": _vm.processStyle
    },
    model: {
      value: (_vm.slider1Value),
      callback: function($$v) {
        _vm.slider1Value = $$v
      }
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "slider-title"
  }, [_vm._v("Retail Savings")]), _vm._v(" "), _c('div', {
    staticClass: "marginRight padding1"
  }, [_c('vue-slider', {
    style: (_vm.style),
    attrs: {
      "data": _vm.slider2Data,
      "width": _vm.width,
      "tooltip": true,
      "disabled": false,
      "piecewise": true,
      "piecewiseLabel": true,
      "piecewiseStyle": _vm.piecewiseStyle,
      "piecewiseActiveStyle": _vm.piecewiseActiveStyle,
      "labelActiveStyle": _vm.labelActiveStyle,
      "processStyle": _vm.processStyle
    },
    model: {
      value: (_vm.slider2Value),
      callback: function($$v) {
        _vm.slider2Value = $$v
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "table1-space",
    attrs: {
      "id": "table1ContainerDiv"
    }
  }, [_c('div', {
    staticClass: "inline-block v-top text-align-left",
    attrs: {
      "id": "table1HeaderContainer"
    }
  }, [_c('data-table', {
    attrs: {
      "data": _vm.table1Header,
      "styles": _vm.tableStyles.offersListHeaderStyles
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-block scrollable",
    style: ({
      width: _vm.scrollable1Width
    }),
    attrs: {
      "id": "table1BodyContainer"
    }
  }, [_c('div', {
    staticClass: "inline-block text-align-left",
    style: ({
      width: ((_vm.table1Data.length * _vm.table1BodyWidth) + "rem")
    })
  }, _vm._l((_vm.table1Data), function(data) {
    return _c('div', {
      staticClass: "inline-block",
      style: ({
        width: (_vm.table1BodyWidth + "rem"),
        "vertical-align": "top"
      })
    }, [_c('data-table', {
      attrs: {
        "functions": _vm.updateChanges,
        "data": data,
        "styles": _vm.tableStyles.offersListDataStyle
      }
    })], 1)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    class: {
      'width_4': true, 'primary-green-bg': _vm.hasChanges, 'light-grey-text': !_vm.hasChanges
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.hasChanges
    },
    on: {
      "click": _vm.submitChanges
    }
  }, [_vm._v("\n          Submit changes\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "change-header-title"
  }, [_vm._v("\n    " + _vm._s('Impact Of Changing Retail Savings') + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "switch-parent"
  }, [_c('span', {
    class: {
      "padding1": true, "color": !_vm.switchToggle
    }
  }, [_vm._v("Graph")]), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.switchToggle),
      expression: "switchToggle"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.switchToggle) ? _vm._i(_vm.switchToggle, null) > -1 : (_vm.switchToggle)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.switchToggle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.switchToggle = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.switchToggle = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.switchToggle = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slider"
  })]), _vm._v(" "), _c('span', {
    class: {
      "padding1": true, "color": _vm.switchToggle
    }
  }, [_vm._v("Table")])]), _vm._v(" "), (_vm.switchToggle) ? _c('div', [_c('div', {
    staticClass: "table1-space",
    attrs: {
      "id": "table2ContainerDiv"
    }
  }, [_c('div', {
    staticClass: "inline-block v-top text-align-left",
    attrs: {
      "id": "table2HeaderContainer"
    }
  }, [_c('data-table', {
    attrs: {
      "data": _vm.table2Headers,
      "styles": _vm.tableStyles.offersListHeaderStyles
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-block scrollable text-align-left",
    style: ({
      width: _vm.scrollable2Width
    }),
    attrs: {
      "id": "table2BodyContainer"
    }
  }, [_c('div', {
    staticClass: "inline-block",
    style: ({
      width: ((_vm.table2Data.length * _vm.scrollableChildrenWidth) + "rem")
    })
  }, _vm._l((_vm.table2Data), function(data) {
    return _c('div', {
      staticClass: "inline-block",
      style: ({
        width: (_vm.scrollableChildrenWidth + "rem")
      })
    }, [_c('data-table', {
      attrs: {
        "data": data,
        "styles": _vm.tableStyles.offersListDataStyle
      }
    })], 1)
  }))])])]) : _vm._e(), _vm._v(" "), (!_vm.switchToggle) ? _c('div', {
    staticClass: "graph-parent"
  }, [_c('div', {
    staticClass: "radio-container"
  }, _vm._l((_vm.lineChartInputOptionArray), function(data) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.picked),
        expression: "picked"
      }],
      attrs: {
        "type": "radio",
        "id": "data"
      },
      domProps: {
        "value": data,
        "checked": _vm._q(_vm.picked, data)
      },
      on: {
        "__c": function($event) {
          _vm.picked = data
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data
      }
    }, [_vm._v(_vm._s(data))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "graph-container"
  }, [_c('vue-chart', {
    attrs: {
      "chart-type": "LineChart",
      "columns": _vm.columns,
      "rows": _vm.rows,
      "options": _vm.options
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49d85fa2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts-simulation/Simulation.vue
// module id = 366
// module chunks = 2